import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field } from 'redux-form';
import ArrowUpBold from 'mdi-react/ArrowUpBoldIcon';
import ArrowDownBoldIcon from 'mdi-react/ArrowDownBoldIcon';
import TrashCanOutlineIcon from 'mdi-react/TrashCanOutlineIcon';
import hiddenField from '../../../shared/components/form/HiddenField';
import renderField from '../../../shared/components/form/TextField';
import renderSelectField from '../../../shared/components/form/Select';
import renderDatePickerField from '../../../shared/components/form/DatePicker';

const marginTop20 = { marginTop: '20px' };
const marginTop35 = { marginTop: '35px' };

class RenderChildren extends PureComponent {
  static moveToUp(fields, index) {
    if (index > 0) {
      fields.swap(index, index - 1);
    }
  }

  static moveToDown(fields, index) {
    if (fields.length - 1 !== index) {
      fields.swap(index, index + 1);
    }
  }

  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  render() {
    const {
      fields,
      meta: { error, submitFailed },
    } = this.props;
    const { moveToUp, moveToDown } = RenderChildren;

    return (
      <div className="form__form-group">
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" size="sm" onClick={() => fields.push({})}>
            Добавить ребенка
          </Button>
        </ButtonToolbar>
        {submitFailed && error && (
          <div className="form__form-group">
            <div>
              <span className="form__form-group-error">{error}</span>
            </div>
          </div>
        )}
        {fields.map((child, index) => (
          <div key={index} className="form__form-group">
            <span className="form__form-group-label">Ребенок # {index + 1}</span>
            <div className="form__form-group-field">
              <Field name={`${child}.name`} component={renderField} type="text" placeholder="Имя ребенка" />
              <Field name={`${child}.id`} component={hiddenField} />
              <div className="form__form-group-icon">
                <ArrowUpBold onClick={() => moveToUp(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <ArrowDownBoldIcon onClick={() => moveToDown(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <TrashCanOutlineIcon onClick={() => fields.remove(index)} />
              </div>
            </div>
            <div className="form__form-group-field" style={marginTop20}>
              <Field
                name={`${child}.gender`}
                component={renderSelectField}
                placeholder="Выберите пол"
                options={[
                  { value: 'male', label: 'мужской' },
                  { value: 'female', label: 'женский' },
                ]}
              />
            </div>
            <div className="form__form-group-field" style={marginTop35}>
              <Field name={`${child}.birthday`} component={renderDatePickerField} placeholder="Дата рождения" />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default RenderChildren;
